import { ApiClient } from '@awj/api-client';

/** Fired when a refresh has failed and the session is genuinely over. */
export const SESSION_EXPIRED = 'awj:session-expired';

/**
 * The API client, built once.
 *
 * Once, because it coalesces concurrent token refreshes internally. Refresh tokens rotate and
 * the server revokes the whole family when it sees one reused, so a second instance refreshing
 * in parallel would sign the member of staff out mid-edit.
 *
 * The admin talks to the same endpoints as the storefront and is authorised by role, so there is
 * no separate admin client — only a different set of paths, which are added below as each slice
 * needs them. It does announce itself, so the API keeps its session in cookies apart from the
 * shop's: signing in here no longer signs the same browser in or out of the shop.
 */
let instance: ApiClient | null = null;

export function client(): ApiClient {
  instance ??= new ApiClient({
    baseUrl: import.meta.env.VITE_AWJ_API_URL ?? 'http://localhost:5092',
    defaultHeaders: { 'X-AWJ-App': 'admin' },
    onSessionExpired: () => {
      // Announced, never acted on. Navigating from here would fight whatever the page is doing,
      // and an unconditional reload is how the storefront once built itself a reload loop.
      window.dispatchEvent(new CustomEvent(SESSION_EXPIRED));
    },
  });

  return instance;
}
